module.exports = __webpack_public_path__ + "main.f5fca7de.wasm";